"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var Tabs_1 = require("../Tabs");
var TabsItem_1 = require("../TabsItem");
var EXAMPLE_SRC = 'components/tabs/examples/index.ts';
var items = [
    'Accounts',
    'Projects',
    'Settings'
];
var TabsExample = /** @class */ (function () {
    function TabsExample() {
        this.align = 'center';
        this.active = 'Projects';
        this.bordered = false;
        this.fluid = false;
        this.isLoading = false;
    }
    TabsExample.prototype.view = function () {
        var _this = this;
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(Tabs_1.Tabs, {
                align: this.align,
                bordered: this.bordered,
                fluid: this.fluid,
                size: this.size
            }, [
                items.map(function (item) { return (0, mithril_1.default)(TabsItem_1.TabItem, {
                    label: [
                        item === 'Settings' && (0, mithril_1.default)(_1.Icon, {
                            name: _1.Icons.SETTINGS,
                            style: 'margin-right: 5px'
                        }),
                        item
                    ],
                    active: _this.active === item,
                    loading: item === 'Projects' && _this.isLoading,
                    onclick: function () { return _this.active = item; }
                }); })
            ])
        ]);
    };
    TabsExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Align'),
            (0, mithril_1.default)(_1.Select, {
                fluid: true,
                defaultValue: 'center',
                options: Object.keys(_1.Align).map(function (key) { return _1.Align[key]; }),
                onchange: function (e) { return _this.align = e.target.value; },
                size: 'xs'
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.fluid,
                label: 'Fluid',
                onchange: function () { return _this.fluid = !_this.fluid; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.bordered,
                label: 'Bordered',
                onchange: function () { return _this.bordered = !_this.bordered; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.isLoading,
                label: 'Loading',
                onchange: function () { return _this.isLoading = !_this.isLoading; }
            })
        ];
    };
    return TabsExample;
}());
exports.TabsExample = TabsExample;
